import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=61a76157&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=61a76157&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a76157",
  null
  
)

export default component.exports